var React = require('react');

function Tiff (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M29.3,8.8V0.2H6v46.6c0,1.6,1.3,2.9,2.9,2.9h35v-35h-8.7C32,14.8,29.3,12.2,29.3,8.8z M17.6,25.6h-3.4v9.5h-2.3v-9.5H8.5\n\t\tv-1.9h9.1V25.6z M21.3,35.2H19V23.7h2.3V35.2z M31.4,25.6h-5.5v2.7h4.8v1.9h-4.8v4.9h-2.3V23.7h7.9V25.6z M41.1,25.6h-5.5v2.7h4.8\n\t\tv1.9h-4.8v4.9h-2.3V23.7h7.9V25.6z","key":0}),React.createElement("path",{"d":"M34.9,12H44L32.3,0.2V9C32.3,10.5,33.4,12,34.9,12z","key":1})]));
}

Tiff.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 50 50","style":{"enableBackground":"new 0 0 50 50"},"xmlSpace":"preserve"};

module.exports = Tiff;

Tiff.default = Tiff;
